import { useEffect, useCallback } from 'react';
import { isNative, platform, initPushNotifications, setStatusBarDark, hideSplash, onAppStateChange, onBackButton, hapticFeedback } from '../utils/mobile';

const NativeProvider = ({ children, onPushToken, onNotification }) => {
  const initNativeFeatures = useCallback(async () => {
    if (!isNative) return;

    try {
      await setStatusBarDark();
    } catch (e) {
      console.log('StatusBar init skipped:', e.message);
    }

    try {
      await hideSplash();
    } catch (e) {
      console.log('SplashScreen hide skipped:', e.message);
    }

    try {
      await initPushNotifications(
        (token) => {
          console.log('Push token:', token);
          if (onPushToken) onPushToken(token);
        },
        (notification) => {
          console.log('Push notification:', notification);
          if (onNotification) onNotification(notification);
        }
      );
    } catch (e) {
      console.log('Push notifications init skipped:', e.message);
    }

    onAppStateChange((isActive) => {
      if (isActive) {
        hapticFeedback('light');
      }
    });

    if (platform === 'android') {
      onBackButton((canGoBack) => {
        if (canGoBack) {
          window.history.back();
        }
      });
    }
  }, [onPushToken, onNotification]);

  useEffect(() => {
    initNativeFeatures();
  }, [initNativeFeatures]);

  return children;
};

export default NativeProvider;
